import React, { useContext, useEffect, useState } from 'react'
import userContext from '../../../context/users/UserContext';
import { changeUserLockStatus, changeUserStatus, getTypistList } from '../../../service/UserService';
import { AuthRoutes, USERTYPES } from '../../../constants/Constants';
import TypistColumns from '../../../constants/Columns/Typist';
import NotAuthorized from '../../../components/NotAuthorized';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import loaderContext from '../../../context/loader/LoaderContext';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '@fluentui/react';
import ListViewV3 from '../../../components/ListViewV3/ListViewV3';
import PasswordResetModal from '../../../components/PasswordResetModal/PasswordResetModal';

const TypistList = (props) => {

    const [t, i18n] = useTranslation();
    const navigate = useNavigate();

    const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);
    const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
    const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [selectedUsername, setSelectedUsername] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [fullName,setFullName]=useState("");

  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [searchParams] = useSearchParams();
  const [dataQueryState, setDataQueryState] = useState({});

    let firmID =
    props.firmId === undefined
      ? searchParams.get("firmId") != null
        ? searchParams.get("firmId")
        : firmId
      : props.firmId;

    const buttonsTopBar = [
        {
          key: "1",
          button: (
            <Link
              key="1"
              to={
                props.firmId === undefined
                  ? AuthRoutes.ADDTYPIST + "?firmId=" + firmId
                  : roles[0] === USERTYPES.ADMIN
                  ? AuthRoutes.ADDTYPIST + "?firmId=" + firmID + "&for=firm"
                  : AuthRoutes.ADDTYPIST + "?firmId=" + firmID + "&for=client"//for what
              }
            >
              <div className="add-button-list-view">
                <PrimaryButton
                  text={t("typist.add-typist")}
                  className={
                    "common-default-active-button list-view-top-buttons-styles"
                  }
                />
              </div>
            </Link>
          ),
        },
      ];

      const options = [
        { key: "username", text: t("user.username") },
        { key: "firstName", text: t("user.first-name") },
        { key: "lastName", text: t("user.last-name") },
        { key: "email", text: t("user.email") },
        { key: "mobile", text: t("user.mobile") },
        { key: "active", text: t("user.action") },
      ];

    function camelToUnderscore(key) {
        var result = key.replace(/([A-Z])/g, " $1");
        return result.split(" ").join("_").toLowerCase();
    }

    const fetchData = async (options) => {
        console.log("--- FetchData ---", options);
        let sortParams = "id";
        let sortyByDir = false;
    
        if (
          options.sortObj.sortFieldValue != undefined &&
          options.sortObj.sortFieldValue.length > 0
        ) {
          sortParams = options.sortObj.sortFieldValue;
          sortyByDir = options.sortObj.sortDir;
        }
    
        const body = {
            paginationDto: {
                pageNumber: options.page,
                pageSize: 10,
                sortField: camelToUnderscore(sortParams),
                sortOrder: sortyByDir,
                filterInput:
                options.filterObj.filterInput == null
                    ? ""
                    : options.filterObj.filterInput,
            },
            firmId: firmID,
            firmAccessList: [],
        };
    
        setLoaderRunning(true);
        ref.current.continuousStart();
    
        const response = await getTypistList(body);
        console.log("---Typist List Response ---", response);
        let data = null;
        let pageCount = null;
        if (response.status === 200 && response.data.result === "SUCCESS") {
            setLoaderRunning(false);
            ref.current.complete();
            data = response.data.data.userList;
            pageCount = response.data.data.totalPages;
        
            return {
                rows: data,
                pageCount: pageCount,
            };
        }else {
            setLoaderRunning(false);
            ref.current.complete();
            return {
                rows: data,
                pageCount: pageCount,
            };
        }
    };
    

    function handleCaching(data) {
        setUpdateCurrentPage(!updateCurrentPage);
        setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
    }

    const handleActionButton = async (event, data, cell) => {
        event.stopPropagation();
        try {
            const response = await changeUserStatus(data);
            if (response.status === 200 && response.data.result === "SUCCESS") {
                // handleCaching(data);
                ReloadData(data, true);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleLockButton = async (event, data, cell) => {
      event.stopPropagation();
      try {
        const response = await changeUserLockStatus(data);
        if (response.status === 200 && response.data.result === "SUCCESS") {
          // handleCaching(data);
          ReloadData(data, false);
        }
      } catch (e) {
        console.log(e);
      }
    };

    function ReloadData(id, actionOrLocked) {
      // setUpdateCurrentPage(() => !updateCurrentPage);
      // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
       let newIndex = -1;
       let newData = dataQueryState?.data?.rows.filter((row, index) => {
         if (row.id == id) {
           newIndex = index;
           return true;
         }
         return false;
       });  
       setDataQueryState(() => {
         const newValue = {
           ...dataQueryState
         };
         if(newValue.data.rows[newIndex] != null){
            if(actionOrLocked){
              newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active;
            }else if(!actionOrLocked){
              newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
            }
         }
         return newValue;
       });
   
     }

    const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (props.firmId === undefined) {
      navigate(
        AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id,
        {}
      );
    } else {
      if(roles[0] === USERTYPES.ADMIN) {
        navigate(
          AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id + "&for=firm",
          {}
        );
      }else {
        navigate(
          AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id + "&for=client",
          {}
        );
      }
    }
  };
  const handleApplyClick = (filterValue) => {
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };
   const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);

  };  

    const columns = TypistColumns(
        userId,
        handleActionButton,
        handleUserClick,
        handleLockButton,
        openPasswordReset
    );
      
    return (
        <>
        <PasswordResetModal
        username={selectedUsername}
        visible={showResetModal}
        onClose={() => setShowResetModal(false)}
        fullName={fullName}
        />
          {(roles[0] === USERTYPES.FIRMADMIN ||
            roles[0] === USERTYPES.ADMIN) ? (
            <ListViewV3
              buttonsTopBar={buttonsTopBar}
              sortDropdownOptions={options}
              fetchData={fetchData}
              columns={columns}
              handleUserClick={handleUserClick}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              sortObj={sortObj}
              setSortObj={setSortObj}
              setPagination={setPagination}
              paginationObj={paginationObj}
              handleApplyClick = {handleApplyClick}
              uniqueKey={"Typist"}
              heading={t("navbar.typist")}
              placeholder={"Username"}
              showFilter={true}
              enhancedFilter={false}
              showSort={true}
              setDataQueryState={setDataQueryState}
              dataQueryState={dataQueryState}
              fullLength={props.fullLength}
              fullLengthForRow={props.fullLengthForRow}
            />
          ) : 
          (
            <NotAuthorized />
          )}
        </>
      );
}

export default TypistList